import app from 'flarum/forum/app';
export default class DropArea {
  view() {
    return m('.catchthefish-drop-area', app.translator.trans('clarkwinkelmann-catch-the-fish.forum.drop-area.message'));
  }
}
flarum.reg.add('clarkwinkelmann-catch-the-fish', 'forum/components/DropArea', DropArea);